<template>
  <div class="home">
    <div class="home-header">
        <div class="title">Just get into the fantastic short drama world!</div>
        <div class="sub-title">BestShort provides you with an exclusive personal drama series platform.</div>
        <div style="margin-top: 54px;">
          <img class="download-btn" src="@/assets/home/home_download_google.png" @click="androidDownload">
          <img class="download-btn" style="margin-left: 60px;" src="@/assets/home/home_download_apple.png" @click="iOSDownload">
        </div>
    </div>

    <div style="margin-bottom: 40px; background-color: #fff; display: none;">
      <div style="width: 1520px; padding: 40px 0; margin: 0 auto;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="font-size: 36px; font-weight: bold;">Popular on BestShort</div>
          <div style="font-size: 18px; cursor: pointer;" @click="toPath('/popular')">
            <span>More</span>
            <img src="@/assets/home/home_more_btn.png" style="width: 20px; height: 20px; vertical-align: -4px;" >
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap; justify-content: space-around;">
          <div class="video-wrapper" v-for="(video, index) in videoList" :key="'v_' + index">
            <img />
            <div class="video-name">Billionaire CEO's Obsession</div>
            <div class="video-tag">Romance</div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #f6f5fa;">
      <div style="width: 1520px; padding: 36px 0; text-align: left; margin: 0 auto;">
        <div style="font-size: 36px; font-weight: bold;">BestShort, a easy way for you to enjoy short drama anytime, anywhere!</div>
        <div style="margin-top: 16px; line-height: 27px; font-size: 21px;">
          <p>TIKSHOW LIMITED, as a new media short-form show series business subsidiary of a well-known domestic listed film and television company, has a rich reserve of production resources and a professional business management team, focusing on creating high-quality short-form show content. We are committed to becoming the industry's leading short drama content platform, leading the market trend and providing users with high-quality and diversified short-form show content.</p>
          <p>As a short-form show content company, we adhere to the concept of "The Content-oriented", focusing on innovation and users’ experiences. We have a professional creative team that constantly explores hot topics and combines them with market demands to carefully plan and produce the content, providing users with a rich variety of content choices.</p>
          <p>Meanwhile, we have a professional management team with rich industry experience and resource integration ability. We will provide comprehensive support and guidance to the company through scientific management and operation mode to help its rapid growth.</p>
          <p>We are well aware that talents are the key to enterprise development. Therefore, we attach great importance to the selection and cultivation of talents. You will have the opportunity to contact the big names in the industry, work, grow and develop with excellent colleagues here. We look forward to your joining us to create a bright future together!</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  components: {
    
  },
  data() {
    return {
      videoList: [1, 2, 3, 4, 5, 6]
    }
  },
  methods: {
    toPath(path) {
      if (this.$router.currentRoute.path != path) {
        this.$router.push(path);
      }
    },
    androidDownload() {
      this.$message('Coming soon');
    },
    iOSDownload() {
      window.open('https://apps.apple.com/us/app/bestshort/id6472161137', '_blank');
    }
  }
}
</script>

<style lang="scss">
  .home-header {
    background: url(~@/assets/home/home_banner_bg2.png) center center no-repeat;
    height: 420px;
    color: #fff;
    overflow: auto;
    .title {
      margin-top: 84px;
      font-size: 50px;
      font-weight: bold;
    }
    .sub-title {
      margin-top: 30px;
      font-size: 24px;
      background-color: rgb(0, 0, 0);
      display: inline-block;
      padding: 8px 25px;
      border-radius: 50px;
    }
  }

  .download-btn {
    cursor: pointer;
    height: 60px;
    width: 180px;
  }

  .video-wrapper {
    width: 228px;
    margin-top: 20px;
    text-align: left;
    color: #000;
    img {
      width: 228px;
      height: 320px;
      background-color: #000;
    }
    .video-name {
      font-size: 21px;
      margin-top: 18px;
    }
    .video-tag {
      font-size: 18px;
      color: #fe3455;
      margin-top: 20px;
    }
  }
</style>